/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink, useLocation } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Icon from "@material-ui/core/Icon";
import { useTranslation } from "react-i18next";
// core components
import AdminNavbarLinks from "@Components/Navbars/AdminNavbarLinks.js";
import CollapsibleListItem from "@Components/CollapsibleListItem/CollapsibleListItem.js";

import styles from "@JssStyles/material-dashboard-react/components/sidebarStyle.js";
import { activeRoute, checkRoutePermission } from "utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Scrollbar } from "react-scrollbars-custom";

const useStyles = makeStyles(styles);

export default function Sidebar(props) {
  const classes = useStyles();
  const { t } = useTranslation();

  const { color, logo, image, logoText, routes } = props;
  let links = (
    <List className={classes.list}>
      {routes.map((prop, key) => {
        let activePro = " ";
        let listItemClasses;
        listItemClasses = classNames({
          [" " + classes[color]]: activeRoute(prop.path),
        });
        const whiteFontClasses = classNames({
          [" " + classes.whiteFont]: activeRoute(prop.path),
        });
        let hasPermission = checkRoutePermission([prop.module]);
        return (
          <div key={key}>
            {prop.collapsible ? (
              <CollapsibleListItem
                key={key}
                prop={prop}
                classes={classes}
                color={color}
              />
            ) : !hasPermission ? null : (
              <NavLink
                to={prop.path}
                className={activePro + classes.item}
                activeClassName="active"
                key={key}
              >
                <ListItem
                  button
                  className={
                    classes.itemLink +
                    listItemClasses +
                    " " +
                    classes.sidebarHover
                  }
                >
                  {typeof prop.icon === "string" ? (
                    <Icon
                      className={classNames(classes.itemIcon, whiteFontClasses)}
                    >
                      {prop.icon}
                    </Icon>
                  ) : (
                    <FontAwesomeIcon
                      fixedWidth
                      icon={prop.icon}
                      className={classes.itemIcon}
                    />
                  )}
                  <ListItemText
                    primary={t(prop.name)}
                    className={classNames(classes.itemText, whiteFontClasses)}
                    disableTypography={true}
                  />
                </ListItem>
              </NavLink>
            )}
          </div>
        );
      })}
    </List>
  );
  return (
    <div>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor="right"
          open={props.open}
          classes={{
            paper: classNames(classes.drawerPaper),
          }}
          onClose={props.handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          <div className={classes.sidebarWrapper}>
            <AdminNavbarLinks />
            {links}
          </div>
          {image !== undefined ? (
            <div
              className={classes.background}
              // style={{ backgroundImage: "url(" + image + ")" }}
            />
          ) : null}
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <Drawer
          anchor="left"
          variant="permanent"
          open
          classes={{
            paper: classNames(classes.drawerPaper),
          }}
        >
          <div className={classes.sidebarWrapper}>
            <Scrollbar>{links} </Scrollbar>
          </div>
          {image !== undefined ? <div className={classes.background} /> : null}
        </Drawer>
      </Hidden>
    </div>
  );
}

Sidebar.propTypes = {
  handleDrawerToggle: PropTypes.func,
  bgColor: PropTypes.oneOf(["purple", "blue", "green", "orange", "red"]),
  logo: PropTypes.string,
  image: PropTypes.string,
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  open: PropTypes.bool,
};
